<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";

export default {
}
</script>


<style lang="scss">
@font-face {
  font-family: "Sukhumvit";
  src: url(./assets/fonts/Sukhumvit/SukhumvitSet-Text.ttf) format("truetype");
  font-weight: normal;
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./assets/fonts/Sukhumvit/SukhumvitSet-Bold.ttf) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "SukhumvitBold";
  src: url(./assets/fonts/Sukhumvit/SukhumvitSet-Bold.ttf) format("truetype");
  font-weight: bold;
}

@import url("https://fonts.googleapis.com/css?family=Sriracha&display=swap");
@import url("https://fonts.googleapis.com/css?family=Gugi&display=swap");

$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "~@fortawesome/fontawesome-free/scss/fontawesome";
@import "~@fortawesome/fontawesome-free/scss/solid"; // fas
@import "~@fortawesome/fontawesome-free/scss/regular"; // far
@import "~@fortawesome/fontawesome-free/scss/brands"; // fab

body {
  background-image: url(./assets/images/bg-front.jpg);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

#app {
  font-family: Sukhumvit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #212529;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.modal {
  font-family: "Sukhumvit" !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5) !important;
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.bar-back {
  font-size: 20px;
  border: 1px #333 solid;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: block;
  padding: 10px;
  background: #222;
  color: lightgoldenrodyellow;
  line-height: 1;
}

.bar-back a {
  color: #aaa;
  text-decoration: none;
}
h5 {
  color: #bd841b;
}
</style>
